import React from "react"
import { StyleSheet, Text } from "react-native"

import Base from "../../base"

export default function VenueNameBanner(props) {
  let venueTitle = props.venue.name
  if (props.venue.externalVenueRef) {
    venueTitle += ` : ${props.venue.externalVenueRef}`
  }

  return <Text style={styles.main}>{venueTitle}</Text>
}

const styles = StyleSheet.create({
  main: {
    backgroundColor: Base.colours.appDarkBlue,
    color: "white",
    width: "100%",
    paddingVertical: 8,
    textAlign: "center",
    fontFamily: Base.fonts.appSemiBold,
    fontSize: 16,
    paddingHorizontal: 30,
  },
})
